(function() {
  // Mobile Sidebar Navigation
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileSidebar = document.querySelector('[data-mobile-sidebar]');
  var mobileSidebarOverlay = document.querySelector('[data-mobile-sidebar-overlay]');
  var mobileSidebarClose = document.querySelector('[data-mobile-sidebar-close]');
  var submenuOpeners = document.querySelectorAll('[data-open-submenu]');
  var submenuClosers = document.querySelectorAll('[data-close-submenu]');

  function openMobileSidebar() {
    if (mobileSidebar && mobileSidebarOverlay) {
      mobileSidebar.classList.add('is-open');
      mobileSidebarOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileSidebar() {
    if (mobileSidebar && mobileSidebarOverlay) {
      mobileSidebar.classList.remove('is-open');
      mobileSidebarOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      // Close all submenus
      document.querySelectorAll('.mobile-sidebar__submenu.is-open').forEach(function(submenu) {
        submenu.classList.remove('is-open');
      });
    }
  }

  function openSubmenu(submenuId) {
    var submenu = document.querySelector('[data-submenu="' + submenuId + '"]');
    if (submenu) {
      submenu.classList.add('is-open');
    }
  }

  function closeSubmenu(btn) {
    var submenu = btn.closest('.mobile-sidebar__submenu');
    if (submenu) {
      submenu.classList.remove('is-open');
    }
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', openMobileSidebar);
  }

  if (mobileSidebarClose) {
    mobileSidebarClose.addEventListener('click', closeMobileSidebar);
  }

  if (mobileSidebarOverlay) {
    mobileSidebarOverlay.addEventListener('click', closeMobileSidebar);
  }

  submenuOpeners.forEach(function(opener) {
    opener.addEventListener('click', function() {
      var submenuId = this.dataset.openSubmenu;
      openSubmenu(submenuId);
    });
  });

  submenuClosers.forEach(function(closer) {
    closer.addEventListener('click', function() {
      closeSubmenu(this);
    });
  });

  // Close sidebar on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileSidebar && mobileSidebar.classList.contains('is-open')) {
      closeMobileSidebar();
    }
  });

  // Bike Selector Modal
  var bikeSelectorOpeners = document.querySelectorAll('[data-bike-selector-open]');
  var bikeSelectorClose = document.querySelector('[data-bike-selector-close]');
  var bikeSelectorOverlay = document.querySelector('[data-bike-selector-overlay]');
  var bikeSelectorModal = document.querySelector('[data-bike-selector-modal]');
  var brandStep = document.querySelector('[data-step="brand"]');
  var modelStep = document.querySelector('[data-step="model"]');
  var backToBrand = document.querySelector('[data-back-to-brand]');
  var brandButtons = document.querySelectorAll('[data-brand]');
  var modelOptions = document.querySelectorAll('.bike-modal__model');

  function openBikeSelector() {
    if (bikeSelectorOverlay && bikeSelectorModal) {
      bikeSelectorOverlay.classList.add('is-open');
      bikeSelectorModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeBikeSelector() {
    if (bikeSelectorOverlay && bikeSelectorModal) {
      bikeSelectorOverlay.classList.remove('is-open');
      bikeSelectorModal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (brandStep && modelStep) {
        brandStep.classList.add('is-active');
        modelStep.classList.remove('is-active');
      }
    }
  }

  bikeSelectorOpeners.forEach(function(opener) {
    opener.addEventListener('click', openBikeSelector);
  });

  if (bikeSelectorClose) {
    bikeSelectorClose.addEventListener('click', closeBikeSelector);
  }

  if (bikeSelectorOverlay) {
    bikeSelectorOverlay.addEventListener('click', closeBikeSelector);
  }

  // Brand selection
  brandButtons.forEach(function(btn) {
    if (!btn.classList.contains('bike-modal__brand')) return;
    btn.addEventListener('click', function() {
      var brand = this.dataset.brand;
      var hasModels = this.dataset.hasModels === 'true';
      var brandUrl = this.dataset.brandUrl;

      if (hasModels && brandStep && modelStep) {
        brandStep.classList.remove('is-active');
        modelStep.classList.add('is-active');

        modelOptions.forEach(function(option) {
          if (option.dataset.brand === brand) {
            option.style.display = 'flex';
          } else {
            option.style.display = 'none';
          }
        });
      } else if (brandUrl && brandUrl !== '#') {
        window.location.href = brandUrl;
      }
    });
  });

  if (backToBrand) {
    backToBrand.addEventListener('click', function() {
      if (brandStep && modelStep) {
        brandStep.classList.add('is-active');
        modelStep.classList.remove('is-active');
      }
    });
  }

  // Close on escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeBikeSelector();
    }
  });
})();
